module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "في-بيت-علي"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في بيت عليّ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فتَح عليّ عينيهِ على الدُّنيا ووجد أمّه مريضةً لا تقوى على مُغادرة فِراشها دون مُعينٍ، ولم يتجاوز الخامسةَ من عُمره حتّى تُوفّيت والدته وتركته وحيدًا في الدُّنيا، وقام جدّه برعايته بعد أن تركه والده وانشغل في عملهِ وحُزنه على موت زوجَته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ولم يبلغِ الخامسةَ عشرة حتّى أصبح وحيدًا تمامًا بعد وفاة جدّه، ورجع مرَّةً أُخرى إلى البيت الَّذي وُلِد فيه ببغداد، والَّذي يقع على مقرُبةٍ من منزل الأستاذ صباح.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: أأنت هنا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ محمّد الرّشيد: نعم، أنا هنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- منذ متى؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- منذُ أن قَدِم رجال الأمن وفَتَّشوا المنزل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سأصعد إلى غُرفتي، يجب أن أغادر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنا أنتظِر تفسيرًا منك على ما حصل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا وقت لديّ، أنا مطلوبٌ وسأُعتَقَلُ في أيّة لحظةٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وهذا ما أريد أن أعرفه، ما الَّذي يحصل؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- الوقت ليس مُناسبًا للحديث، يجب أن أغادر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- على الأقلّ أخبرني: أين ستذهب؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إلى بيت جدّي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لكنَّك لن تكون بعيدًا عن خطر الاعتقال هناك، تعالَ معي إلى إسطنبول.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا أريد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وهذه الفتاة، مَن هي؟ وكيف ستتركها هنا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حاوَل محمّد أن يعرض عليه المساعدة قائِلًا: إن لم يكن لديك مانعٌ..")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لديّ مانعٌ! هذه الفتاة أمانةٌ عندي، سأهتمّ بأمرها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لماذا كلُّ هذا العِناد يا عليّ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يردّ عليّ عليهِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أتفعل هذا لأنَّني تركتك؟! أنت لا تعلم الظُّروف الَّتي..")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أرجوكَ، لا تفتح هذا الموضوع، لأنَّ ما ستسمعه منّي سيؤلمك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وأنا مستعدٌّ لسماعك حتّى وإن تألمّت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("زَفَر عليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- امنَحني الفرصة لِـ...")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتَ محمّد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إلى اللِّقاء يا محمّد الرّشيد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أهكذا تودّع والدك؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- علاقتُنا ليست كأيّ علاقةٍ طبيعيَّةٍ بين وَلَدٍ وأبيه لأودِّعك بحرارةٍ أو لِأتمنّى لقاءك مُجدّدًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لو أردتَ لها ستُصبِح كذلك، فقط لو أعطيتني فُرصةً، أنا نادِمٌ جدًّا على كلِّ شيء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تشغَلني أكثر، بَقِي هناك مشوارٌ أخيرٌ قبل أن أتوجَّه إلى المَحطّة، إن كنتَ تريد مساعدتي حقًّا أوصِلني إلى قصر رفعت باشا الهاشم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كيف هذا وهُم يفتّشون عنك في كلِّ مكانٍ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تقلق، سأتنكَّر ولن يتعرَّفوا عليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتهى من تنكُّرِهِ وأخذ الفتاة وركب سيّارة والدهِ مُتجهَيْن إلى القصر، ثمَّ قفز عن السّور ودخل إلى الحديقة، ومِن ثَمَّ تسلَّق الشّجرة القريبة ودخل إلى الشّرفة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أعجبتني فكرةُ دخولِك إلى الشّرفة وفي هذا الوقت، رومانسيّ جدًّا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- حقًّا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- نعم، لكن أخبِرني: كيف قفزتَ من فوق سور القصر وصعدتَ إلى شُرفتي دون أن يلُاحظك أحدٌ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رد عليّ: \"اعتدنا على هذا الأمر، فلا يمضي يومٌ دون أن نقفز من سطحٍ أو نتسلَّق سورًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لكن إلى متى يا عليّ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يردّ على سؤالها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: سأغادر اللَّيلة يا علياء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هل يجب عليك المُغادرة؟ ألا يمكنك الاختباء هُنا؟ سأدَبّر لك مكانًا آمِنًا، لديّ معارفٌ وسيساعدونك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لستُ وحدي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- بيت جدِّك بعيدٌ جدًّا، كيف سأتحمَّل بُعدَكَ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هي مسألة وقتٍ، سأرجع لا تقلَقي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كيف لا أقلق؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تقلقي، عندما تهدأ الأمور سأرجع وأطلب يدك من الباشا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أتظنُّ بأنَّه سيوافق؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يُجِبْ، بل نظر إلى نافذة غرفة رفعت وكان الضّوء مشتعلًا وقد انتصف اللَّيل، تقدَّم بضع خطواتٍ وعيناه على نافذة الغُرفة ثمَّ قال: لم ينَم بعد؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- آه لو رأيت حاله يا عليّ، انْهَار تمامًا منذ أن سمعَ باعتقال عزّام، أنا خائِفةٌ عليه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أرجو ألَّا يطول بقاؤه في السّجن هذه المرّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالَت علياء بنبرة حزينةٍ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إلى متى يجب أن نعيش في هذا القلق والخوف؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن أعيد لك نفس الكلامِ يا علياءُ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- عليّ...")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطعَ كلامها: علياء! ليس وقتهُ، يكفيني ما أنا فيه من حزنٍ على صاحبي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّت علياء وقد تغيّرت ملامح وجهها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تذكره أمامي، لا يهمّني ما سيحلُّ به.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ما هذا الكلام يا علياء؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا أطيقه، لكنّني مُجبَرةٌ على رؤيته من أجل خالتي منيرة، أنت لا تعلم كم أحبّها، هي الَّتي رَعَتْني واهتمَّتْ بي منذ الصّغر، آه يا عليّ لو ترى حالتها، لا يستحقُّ ذلك الأحمق حُبّها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- مسكينةٌ السّيدة منيرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- عليّ! أتظنّ بأنَّهم سيشنقونه؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتت، ثمَّ ابتسمَت واستأنفت كلامها وقالت: لو فعلوها سأكون ممتنَّةً لهم بالطّبع.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ بتجهُّم: علياء!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أعرف أنَّه صديقك، لكنَّني أكرهه، فليتعفَّن في السّجن ذلك المغرور المُتعجرف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا فائدة منكِ، لا أدري إلى متى ستظلّان هكذا، على الأقلّ راعي مشاعر خالتكِ المسكينة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تُتعِبوا عقولكم بالتَّفكير في الباشا الصّغير، أنا واثقةٌ بأنَّ جدَّه سوف يفعل المُستحيل ليُخرِجه من السّجن.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- الأمر مختلفٌ هذه المرّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أتظنّ أنَّ الباشا سيترك حفيده المُدلَّل يواجه مصيره المجهول دون أن يساعده؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنتِ لستِ مُدركةً الوضع الَّذي هو فيه عزّام الآن، هل نسيتِ أن علاقة الباشا ليست كالسّابق مع أصدقائه في الحُكومة بسبب عزّام، أصبح الأمر صعبًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اطمئنّ، سيخلّص الباشا حفيده من السّجن، وبالمقابل سيطلب منه أن يتولّى أمور الشّركة الجديدة بدلًا من عمّي عزيز وابن خالي الغائب هاشم، وبهذا سيمتلك رِقابَنا جميعًا ويحدِّد مصير كلِّ فردٍ في هذه العائلة، هل أدركتَ الآن الوضع الَّذي سأكون فيه وقتَها؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسم عليّ من استنتاج علياء وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- آه يا علياء! أضحَكتِني، لا أتخيَّل أن يكون عزّام خليفة جدّك الباشا، أظنُّ أنَّ عزّام لو خلَف الباشا فأوَّل أمرٍ سيُصدره هو منعكِ حضور الحفلات والسّهرات والخروج من المنزل، وسيتفنَّن في طُرُق إحزانِكِ وضَرْبك كالعادة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّت علياء بوجهٍ يعبّر عن غضبها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- الحمد لله أنَّك أدركت أخيرًا ما الَّذي ينتظرني في هذا المنزل لو قَبِل عزّام عرض جدّي، سوف يُحوِّل حياتي إلى جحيمٍ، إنَّه يكرهني منذ أنْ كنّا صغارًا، آه يا عليّ كم أرجو أن يرفض عرض جدّي وينصرف إلى نِضاله!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كوني واثقةً أن عزّام لا يهمّه أبدًا عرْض جدّك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أتمنّى ذلك حقًّا من كلِّ قلبي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يجب أن أغادر الآن، لكن قبل ذلك لي رجاءٌ عِندك؛")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- قُل، أسمعك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اهتمّي بفاطمة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اطمئنّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وما الَّذي ستقولينَه للباشا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تقلق، لن يعترض الباشا على وُجود الطّفلة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هل أنتِ متأكّدة؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- صحيحٌ أنَّ جدّي رجلٌ عنيدٌ وعصبيّ لكنَّه لن يرفضَ مُساعَدتها، صدِّقني! إنّ جدّي يحمل قلبًا طيّبًا وليس كما يَصِفه صديقك بأنَّه متحجِّر القلب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تلومي عزّام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سأقول لك شيئًا عن الباشا؛ لن يعاديك ما لم تكسر كلامهُ أو تخالف رأيه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أتعتقدين أنّ ما يفعله جدّك هو الصواب؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هذا ليس مُهمًّا الآن، المُهمّ نحن، ماذا عنا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أعرف أنّ جدك لن يقبل بي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لذلك يجب عليك أن تُعيد النَّظر فيما تفعله.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لكن عزّام أيضًا يُشاركني نفس الأفكار و...")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أوو، ذاك عزّام، حفيد رفعت باشا الهاشم، يحقُّ له ما لا يحقّ لغيرهِ، فهِمت!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- آسف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ماذا تقصد؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن أخالف نفسي ليقبَل بي الباشا صهرًا له.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ماذا عنّي أنا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنا لا أعرف ماذا ينتظرني الآن خارج أسوار هذا القصر، ولكنَّني على وعدي لك بالزّواج، وفي أوَّل فرصةٍ سأرجع وأطلب يدك وآخذك معي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وإن رفَض!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا يهمّني، سآخذك من هذا القصر وأنا أنظر في عينيه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هل يجب علينا مواجهة الباشا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لستُ خائفًا من مواجهته، سأفعل لو تطلَّب الأمر ذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- دائمًا تُصعِّب الأمور.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لستُ أنا من يُصعِّب الأمور يا علياء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لنهرب إذًا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد أن أنهت علياء جملتها قال ضاحكًا بصوت عالٍ: آه يا علياء!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اخفض صوتك، ما بك؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وما يَحِقّ لعلياء حفيدة رفعت الهاشم لا يحقُّ لشخصٍ عاديٍّ مثل الأستاذ صباح، دائمًا كنتِ تنتقدين الأستاذ لأنَّه قام بتحدّي جدّك وهرب مع خالتك، وأنتِ نفسك الآن كنت ستَفعلين ما فعلاه لينجوَا بحُبّهما، اكتشفتُ بأنَّكم جميعًا تُشبهون الباشا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكت عليّ قليلًا ثمَّ قال: إلّا عزّام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وهذا ما أضحكك إذًا! يجب أن تعرف أنَّ الباشا وُلِد من جديدٍ يا عليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إنْ حصل هذا فلن يكون عزّام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن يكون غير عزّام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يردّ على كلامها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرت علياء إلى سيّارة محمّد الرّشيد وقالت: والدك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- نعم، والفتاة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سأنزل الآن وأستلمها من أبيكَ، وهذه فرصةٌ لأتعرَّف على حماي المستقبليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وقولي لوالِدي إنّني غادرت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ألن تودّعه؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتَ لتقولَ لهُ علياء: فهمتُ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ودَّعها ونزل من الشّرفة، ثمَّ مشى بهدوءٍ إلى أن وصل إلى سور القصر الخلفيِّ كي لا يراه والِده، فقد كان يقف بسيّارته أمام القصر، تسلَّق السّور ونزل خارج القصر، نظَّف مِعطفه من الغُبار العالِق وعيناه على الشّارع والتقط قُبَّعته من الأرض، نفَضَها ووَضَعها على رأسه ومشى بمحاذاة السّور، ثمَّ إلى الطّرُق الفرعيَّة إلى أنْ وصل. طوال الطّريق يتذكَّر ما دار بينه وبينها وقد عَلِقت جُملتها الأخيرة في عقله:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("\"إذا كان القدَر سيعيدُ رِفْعت الهاشم من جديد فلن يكون عزّام.\"")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وبينما هو غارقٌ بالتَّفكير لم ينتبه إلى وجود رجال الأمن في المحطَّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اسْتَفاق من صدمته ولمَعتْ فكرةٌ وحيدةٌ في رأسه على الفور.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتبهَ إليه رجال الأمن وحاولوا اللِّحاق به، لكنَّ المفاجأة أخَّرتهم قليلًا حتّى ابتعد ونجَح في التخلُّص منهم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ظننتُ أنَّهم سيمسكون بي، كنت سأستسلم في آخر لحظةٍ، إلى أن ظهرتِ وساعَدتِني، لقد أنقذتِني، شكرًا لك"), _c('strong', [_vm._v(". قالها للفتاةِ الَّتي طلَّت من الباب ومدَّت يدها له لتساعِده.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّت عليه الفتاة: لا داع للشّكر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قال لها: أُدْعَى عَلِيًّا، ماذا قلتِ اسمكِ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّت: لم أَقُلْ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ارْتَبك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالت الفتاة: اسمي حياة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعادَ قولَهُ: وأنا عليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أعتقد أنَّك لم تَخرج بعدُ من الصدمة، لقد عرَّفْتني بنفسِك مرَّتين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- صحيح!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظلَّت تنظر إليه وهو مُرْتبككٌ ثمَّ قالت: اسمح لي، أريد المرور.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- طبعًا، تفضّلي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالها مُبتسمًا وظلَّت تلك الابتسامة على شفتيهِ وهو يتأمَّل تلك العينين المُجهدَتَيْن وكأنَّ صاحبتهما كانت في سفرٍ طويلٍ لم تَذُقْ عيناها طعمَ الرّاحة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شعرتْ حياة بالارتباك من نظراته وقالت لهُ: لَمْ تُفسح لي الطريق!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أوه، آسف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مرَّت من أمامه مُتَّجهةً إلى مكانها، ولكنَّ عليًّا ظلّ واقفًا مكانه عند الباب، اختَفت ابتسامته تدريجيًّا بمجرَّد أن جلسَت مكانها، تحرَّك بخطواتٍ بطيئةٍ نحوها واستأذنها ليجلس مقابِلها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صارت تجلسُ أمامه مباشرةً، غَرِق عليّ في حفظ تفاصيل وجهِها المُجْهَدِ وحركاتها، تخلَّل الهواء المندفع من النّافذة خَصْلات شعرها الطّويلة وبدأ بالتّلاعُب بها بطَيْشٍ لكنَّه لم يُفلح في إزالة بقايا العِطْر العالِق من أنفاسِها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ارتسمت على شفتيها شِبهُ ابتسامةٍ عندما تذكَّرت كيف فَقَدَ توازُنه وأحاطها بذراعيهِ عندما اندفع بقوَّةٍ إلى المركَبة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سألها مُقاطِعًا خيالاتها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كنتُ مُلاحَقًا من رجال الأمن، وبالرّغم من ذلك ساعدتِني، لم تخافي مِنّي، أَعْني ألم يَخْطر في بالك للحظةٍ بأن أكون لصًّا أو قاتلًا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّت حياة بهدوءٍ: أبدًا لم يَخْطر في بالي ذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لنفترض لو كنتُ مُجر..")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطعته حياة: مُستحيل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتت حياة ولم تُكمل، ولكنّها في نفس الوقت كانت في حوارٍ مع نفسها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا أذكر أنّني كنتُ في يومٍ ما بهذه الحالة، ماذا يحدث لي؟ لماذا أنت؟ من أنت؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("علي مُقاطعًا خيالاتها: مُستحيل!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّت حياة: أَعْني مَظْهرك لا يوحي بذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صمتَ وهو يُحدِّق في عَيْنيها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطعتْ صمتَه: يجب ألَّا تنسى أنّك أصبحتَ مدينًا لي لأنّني أنقذتُكَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا أظنُّ أنّني أستطيع نسيانَكِ، أو نسيان هذه اللّيلة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صمتَتْ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سحَبَ نظَراتِه عن وجهها وبدأ ينظر من النّافذة مُستغرِبًا من حاله، وحاول أن يستجمع نفسه ويُسيطرَ على كلماته الَّتي بدأتْ تخونه، ولكن سُرعان ما اشتاق للنَّظر إليها من جديدٍ وبدأ باختلاس النَّظر ومراقبتها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تكلَّمي، أريد الاستمتاع بسماع صوتكِ، وإن طال حديثنا إلى ما لا نهاية، اقتربي فلم أكتفِ، ولم تشبع روحي من لحظاتٍ قَسَمها لي القدَر بين ذراعيكِ، أريد حضنكِ وطنًا فأنا مهاجِر أرهقَه الشتاتُ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اعتَدَل في جِلْسته المائلة ورجع بظهره للوراء مُستندًا وبعينيه يبحث في تفاصيل ذلك الوجه المألوف ويحفظ تلك الملامحَ المُرهَقة، وأغلقَ عينيه مُستسلمًا للنّوم ولم يستيقظ إلّا على صوتِ رجلٍ ينادي: "), _c('strong', [_vm._v("حياة!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يلتَفتان إلى مصدر الصّوت:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("\"عمّي!\" تقفز حياة وتُعانِقه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا يصدّق عليّ ما يراه، ويتقدَّم نحوهما بتعجُّبٍ وعلى وجهه ابتسامةٌ ممزوجةٌ باستغرابٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: العمّ مالك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يلتفت مالكٌ إلى مصدر الصوت: عليّ! لا أصدّق!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسم عليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يقول مالك: نعم، إنَّه أنت، عليّ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: كيف حالُك؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يردّ العمّ مالِك وهو لا يزالُ مُندهشًا: أنا بخيرٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يبدو على حياة الاستغراب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: لم تعرفيه أليس كذلك؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حياة: لا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يقول مالك: عليّ ابن عمتك، ابن المرحومة معالي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فتحت عينيها مُندهشةً.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: نعم، عليّ. غادرَ البلدة قبل سنواتٍ، ألا تذكرينه؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: لا تَلُمْها، لأنّني لم أكن أختلط بالنّاس كثيرًا عندما كنت أعيشُ هنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حياة: اعذرني لأنّني لم أتعرّف عليك، فقد قضيتُ معظم سنوات حياتي في إسطنبول.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قطع مالكٌ كلامها وهو ينظر إلى عليّ باستغرابٍ شديدٍ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ما سبب زيارتكَ المفاجِئة يا عليّ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّ عليّ: سأخبرك بكلِّ شيءٍ لاحقًا، يجب أن أغادر الآن، سأبحث عن أصدقائي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: ألستَ وحدك؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: معي أصدقائي وسآخذهم معي إلى بيت جدّي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قال مالك: بيت جدّك الَّذي لا يصلح لعيش البشر!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أعلم بأنَّه يحتاج إلى إصلاحاتٍ، سنفعل ما بوِسعنا لجعله مكانًا مُناسبًا للعيش، ليس لدينا خيارٌ آخر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لوَّحَ عليّ بيده عندما لَمَح أصحابه، ثمَّ تقدَّم نحو مالك ليودِّعه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إلى أين؟ تعتقد حقًّا بأنّني سأتركك تذهب إلى ذلك المكان!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتّ عليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن تَذْهبوا إلى أيّ مكانٍ، ستأتون معي.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4717c644","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch014.vue
// module id = 102
// module chunks = 0